import checklistService from '@/service/checklist'
export default {
  getListChecklist ({commit}, payload) {
    return new Promise((resolve, reject) => {
      checklistService.getListChecklist(payload.page, payload.per_page, payload.search, payload.sort, payload.status, payload.organization_id, payload.is_calendar, payload.ctg).then(res => {
        commit('getListChecklist', res.data)
        resolve(res.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  getListChecklistAll ({commit}, payload) {
    return new Promise((resolve, reject) => {
      checklistService.getListChecklist(payload.page, payload.per_page).then(res => {
        commit('getListChecklistAll', res.data)
        resolve(res.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  selectCtg ({commit}, payload) {
    commit('selectCtg', payload)
  },

  createChecklist ({commit}, payload) {
    return new Promise((resolve, reject) => {
      checklistService.createChecklist(payload.checklist).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  updateChecklist ({commit}, payload) {
    return new Promise((resolve, reject) => {
      checklistService.updateChecklist(payload.checklist).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  showChecklist ({commit}, payload) {
    return new Promise((resolve, reject) => {
      checklistService.showChecklist(payload.checklist).then(res => {
        commit('showChecklist', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  destroyChecklist ({commit}, payload) {
    return new Promise((resolve, reject) => {
      checklistService.destroyChecklist(payload.checklist).then(res => {
        commit('destroyChecklist', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  approvalChecklist ({commit}, payload) {
    return new Promise((resolve, reject) => {
      checklistService.approvalChecklist(payload.checklist).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  rejectChecklist ({commit}, payload) {
    return new Promise((resolve, reject) => {
      checklistService.rejectChecklist(payload.checklist).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  addChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      checklistService.addChecklistItem(payload.checklist, payload.checklist_items).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  closeChecklist ({commit}, payload) {
    return new Promise((resolve, reject) => {
      checklistService.closeChecklist(payload.checklist, payload.closing_date).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  correctiveChecklist ({commit}, payload) {
    return new Promise((resolve, reject) => {
      console.log('ABC', payload)
      checklistService.correctiveChecklist(payload.checklist, payload.end_corrective_date, payload.checklist_item).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  inProgressChecklist ({commit}, payload) {
    return new Promise((resolve, reject) => {
      checklistService.inProgressChecklist(payload.checklist).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  duplicateChecklist ({commit}, payload) {
    return new Promise((resolve, reject) => {
      checklistService.duplicateChecklist(payload.checklist).then(res => {
        commit('duplicateChecklist', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/checklist/actions.js